import { render, staticRenderFns } from "./CareersJobList.vue?vue&type=template&id=8a5cc56e&"
import script from "./CareersJobList.vue?vue&type=script&lang=ts&"
export * from "./CareersJobList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BContainer: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/BContainer.vue').default})
